const BG_IMAGE = 'https://public.readdy.ai/ai/img_res/58ea55da45b353756bdf9889d7a20ad3.jpg';

export default function FinalCTA() {
  const scrollToEstimate = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('estimate')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative py-32 md:py-40 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img src={BG_IMAGE} alt="Mississippi Gulf Coast roofing" className="w-full h-full object-cover object-center" />
      </div>
      {/* Dramatic layered overlays */}
      <div className="absolute inset-0 bg-gradient-to-b from-ink/75 via-ink/80 to-ink/95"></div>
      <div className="absolute inset-0 bg-gradient-to-r from-ink/50 via-transparent to-ink/50"></div>

      {/* Texture overlay */}
      <div className="absolute inset-0 opacity-3"
        style={{ backgroundImage: 'repeating-linear-gradient(0deg, rgba(201,169,97,0.06) 0, rgba(201,169,97,0.06) 1px, transparent 0, transparent 60px)' }}>
      </div>

      {/* Top gold line */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent"></div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 md:px-8 text-center">
        <div className="flex items-center justify-center gap-4 mb-8">
          <span className="w-12 h-px bg-gold/60"></span>
          <span className="text-[10px] font-bold tracking-super uppercase text-gold/80">All Done Roofing LLC</span>
          <span className="w-12 h-px bg-gold/60"></span>
        </div>

        <h2 className="text-white leading-none mb-8">
          <span className="block font-serif italic text-2xl md:text-3xl lg:text-4xl text-white/50 mb-3">
            Your roof is your home&apos;s first line of defense.
          </span>
          <span className="block font-condensed font-bold text-6xl md:text-8xl lg:text-[104px] uppercase tracking-tighter leading-none">
            PROTECT IT.
          </span>
          <span className="block font-serif italic text-2xl md:text-3xl text-gold mt-3">
            Built to Last.
          </span>
        </h2>

        <p className="text-white/50 text-base md:text-lg leading-relaxed max-w-2xl mx-auto mb-14 font-light">
          Don&apos;t wait for a small issue to become a major expense. Our GAF Certified team is ready to inspect, assess, and deliver a roofing system engineered to handle Gulf Coast conditions for decades — backed by full warranty.
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
          <a href="#estimate" onClick={scrollToEstimate}
            className="inline-flex items-center justify-center gap-3 bg-gold text-ink font-bold text-[13px] tracking-widest uppercase px-12 py-5 rounded hover:bg-gold-light transition-colors cursor-pointer whitespace-nowrap">
            <i className="ri-calendar-check-line"></i>
            Request a Free Estimate
          </a>
          <a href="tel:2285473887"
            className="inline-flex items-center justify-center gap-3 border border-white/20 text-white font-semibold text-[13px] tracking-widest uppercase px-12 py-5 rounded hover:border-gold/50 hover:text-gold transition-colors cursor-pointer whitespace-nowrap">
            <i className="ri-phone-fill text-gold"></i>
            (228) 547-3887
          </a>
        </div>

        {/* Trust strip */}
        <div className="flex flex-wrap justify-center gap-8 md:gap-12 pt-10 border-t border-white/8">
          {[
            { icon: 'ri-shield-check-fill', label: 'Licensed & Insured' },
            { icon: 'ri-medal-2-fill', label: 'GAF Certified' },
            { icon: 'ri-award-fill', label: 'Fortification Certified' },
            { icon: 'ri-checkbox-circle-fill', label: 'Free Inspections' },
            { icon: 'ri-star-fill', label: '5-Star Rated' },
          ].map(t => (
            <span key={t.label} className="flex items-center gap-2 text-[10px] font-semibold tracking-widest uppercase text-white/30">
              <i className={`${t.icon} text-gold/70 text-xs`}></i>
              {t.label}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
